import PropTypes from 'prop-types';
import React from 'react';
import styles from './ReservationDetails.less';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';

export default ContentConnector({prefix: 'success_'})(class extends React.Component {
    static propTypes = {
        date: PropTypes.string.isRequired,
        time: PropTypes.string.isRequired,
        party: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        isCustomDesign: PropTypes.bool,
        isMobile: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        isCustomDesign: false,
        className: ''
    };

    render() {
        const { date, time, party, isCustomDesign, className, content, isMobile } = this.props;

        return (
            <div style={{width: '100%'}}>
                <div className={`${styles.wrapper} ${isCustomDesign ? styles.custom : ''} ${className} ${isMobile ? styles.mobile : ''}`}>
                    {this._getDetailElement(date, content.get('date_label'), 'success_date')}
                    {this._getDetailElement(time, content.get('time_label'), 'success_time')}
                    {this._getDetailElement(party, content.get('party_label'), 'success_party_size')}
                </div>
                {this._renderCustomFields()}
            </div>
        );
    }

    _renderCustomFields = () => {
        const { isCustomDesign, className, isMobile, customFields } = this.props;

        if (_.isEmpty(customFields)) return null;

        // Using same row/col elements as details but using 1 col per row and setting it to width 100%
        return _.map(customFields, (field, index) => (
            <div className={`${styles.wrapper} ${isCustomDesign ? styles.custom : ''} ${className} ${isMobile ? styles.mobile : ''}`}>
                <div className={styles.detailBox} style={{width: '100%'}}>
                    <div key="detail" className={`${styles.detail} ${styles.customFieldValue}`} data-hook={`custom-field-value-${index}`}>{field.value}</div>
                    <div key="label" className={styles.label} data-hook={`custom-field-label-${index}`}>{field.label}</div>
                </div>
            </div>
        ));
    }

    _getDetailElement = (detail, label, dataHook) => {
        return (
            <div className={styles.detailBox}>
                <div key="detail" className={styles.detail} data-hook={dataHook}>{detail}</div>
                <div key="label" className={styles.label}>{label}</div>
            </div>
        );
    };
});